import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFence = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 22 22",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Fence",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Path_222",
			d: "M2.8,19.7c-.3,0-.5-.4-.5-.7v-2.4h-1c-.2,0-.4-.2-.5-.5v-2.3c0-.8.3-.7.6-.7h.9v-2.9h-1.1c-.2,0-.4-.4-.5-.6v-2.3c0-.5.4-.6.7-.6h.8v-1.6s0-.3,0-.4c.3-.8.8-1.5,1.3-2.1.4-.5.8-.5,1.2,0,.5.7,1,1.5,1.4,2.3v1.7h3v-1.6s0-.3,0-.4c.4-.7.8-1.5,1.3-2.1.2-.3.6-.4.9-.2,0,0,.2.1.2.2.5.7.9,1.4,1.3,2.1.2.5,0,.3,0,.4v1.6h3v-1.7c.4-.8.9-1.6,1.4-2.3.2-.3.6-.4.9-.2,0,0,.2.1.2.2.5.8,1,1.6,1.4,2.4v1.6h.8c.3,0,.5.2.7.5v2.5c0,0-.3.5-.5.5h-1v2.9h.9c.2,0,.5.3.6.5v2.5c0,.2-.2.4-.5.5h-1v2.4c0,.3-.2.5-.5.7h-2.9c-.2,0-.4-.2-.5-.5v-2.6h-3v2.7c0,.2-.3.4-.5.5h-2.9c-.2,0-.4-.2-.5-.5s0-.3,0-.3v-2.4h-3v2.6c0,.2-.3.4-.5.5h-2.9,0ZM9.1,10.3h-3v2.9h3v-2.9ZM15.9,13.2v-2.8h-2.9v2.9h3,0Z"
		})
	})
});
export default SvgFence;
